import React from "react";
import Header from "./Header";
import UserReports from "../admin/UserReports";

export default function LayoutUserReports() {
  return (
    <>
      <Header />
      <UserReports />
    </>
  );
}
